import { Warning as WarningIcon } from '@mui/icons-material';
import React from 'react';

import { CloseDialogHandler, Dialog } from '../Dialog';

type Props = {
  open: boolean;
  title: string;
  message: string;
  stayLabel: string;
  leaveLabel: string;
  onStay: () => void;
  onLeave: () => void;
};

export const UnsavedChangesDialog: React.FC<Props> = ({
  open,
  title,
  message,
  stayLabel,
  leaveLabel,
  onStay,
  onLeave,
}) => {
  const handleClose: CloseDialogHandler = ({ ok }) => (ok ? onLeave : onStay)();

  return (
    <Dialog
      open={open}
      title={title}
      titleStartIcon={<WarningIcon sx={{ color: 'warning.light' }} />}
      okLabel={leaveLabel}
      cancelLabel={stayLabel}
      onClose={handleClose}
    >
      <div>{message}</div>
    </Dialog>
  );
};
